import { render, staticRenderFns } from "./room-videos.vue?vue&type=template&id=259137d8"
import script from "./room-videos.vue?vue&type=script&lang=js"
export * from "./room-videos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports